/* Favoritos (coração), igual às lojas grandes (Erick, 11/10, referência Sunglass Hut).
   Fica guardado só neste navegador (localStorage "vibe_favoritos", lista de handles,
   o mais recente primeiro), sem precisar de conta nem e-mail.
   Qualquer botão com data-fav="handle-do-oculos" vira coração: card do catálogo,
   página do produto. Os contadores com data-fav-n mostram quantos tem (o do cabeçalho).
   A página de favoritos (collection.favoritos) escuta o evento "vibe:favoritos". */
(function () {
  var CHAVE = 'vibe_favoritos';

  function ler() {
    try {
      var l = JSON.parse(localStorage.getItem(CHAVE)) || [];
      // a versão antiga guardava o id numérico do produto: fica só o que é handle
      return l.filter(function (h) { return typeof h === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(h); });
    } catch (e) { return []; }
  }
  function gravar(l) {
    try { localStorage.setItem(CHAVE, JSON.stringify(l)); } catch (e) { /* navegador sem espaço ou anônimo */ }
  }

  function pintar() {
    var l = ler();
    document.querySelectorAll('[data-fav]').forEach(function (b) {
      var on = l.indexOf(b.dataset.fav) > -1;
      var nome = b.dataset.favNome || 'este óculos';
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', (on ? 'Tirar dos favoritos: ' : 'Curtir: ') + nome);
      b.title = on ? 'Nos seus favoritos' : 'Curtir';
    });
    document.querySelectorAll('[data-fav-n]').forEach(function (n) {
      n.textContent = l.length;
      n.hidden = !l.length;
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fav]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var l = ler(), h = b.dataset.fav, i = l.indexOf(h), curtiu = i < 0;
    if (curtiu) l.unshift(h); else l.splice(i, 1);
    gravar(l);
    if (curtiu) {
      b.classList.remove('pulou');
      void b.offsetWidth;   // reinicia a animação
      b.classList.add('pulou');
      if (window.vibeDL) window.vibeDL.push({ event: 'add_to_wishlist', item_id: h, item_name: b.dataset.favNome || h });
    }
    pintar();
    document.dispatchEvent(new CustomEvent('vibe:favoritos', { detail: { lista: l, handle: h, curtiu: curtiu } }));
  });

  // curtiu em outra aba: atualiza esta também
  window.addEventListener('storage', function (e) { if (e.key === CHAVE) pintar(); });

  window.vibeFavoritos = { lista: ler, pintar: pintar };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pintar);
  else pintar();
})();
